<app-i18n-dictionary>
    <span [attr.transid]="fieldFirstNameTextId" i18n="@field-first-name">First Name</span>
    <span [attr.transid]="fieldLastNameTextId" i18n="@@field-last-name">Last Name</span>
    <span [attr.transid]="fieldCompanyTextId" i18n="@@request-quote-form_field-company">Company</span>
    <span [attr.transid]="fieldStreetTextId" i18n="@@request-quote-form_field-street">Street</span>
    <span [attr.transid]="fieldCountryTextId" i18n="@@request-quote-form_field-country">Country</span>
    <span [attr.transid]="fieldZipTextId" i18n="@@request-quote-form_field-first-zip">Zip</span>
    <span [attr.transid]="fieldCityTextId" i18n="@@request-quote-form_field-first-city">City</span>
    <span [attr.transid]="fieldVatInTextId" i18n="@@request-quote-form_field-first-vat-in">VAT Reg No</span>
</app-i18n-dictionary>

<div class="menu-container">

    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="closeRequestQuote()">←</button>
        </div>
        <h3 i18n="@@request-quote_request-quote" *ngIf="!isOrder" class="headline">Request your quote</h3>
        <h3 i18n="@@request-quote_order-quote" *ngIf="isOrder" class="headline">Order your quote</h3>
    </div>

    <div class="order-request-form" [formGroup]="form">
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldFirstNameTextId)"
                   formControlName="firstName" required [maxlength]="firstNameMaxLength">
            <mat-error *ngIf="firstNameControl.hasError('required') && firstNameControl.touched"
                       i18n="@@request-quote-form_error-first-name-required">Please enter your first name
            </mat-error>
            <mat-error *ngIf="firstNameControl.hasError('maxlength')"
                       i18n="@@request-quote-form_error-first-name-maxlength">
                Your first name can't have more than {{firstNameMaxLength}} characters
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldLastNameTextId)"
                   formControlName="lastName" required [maxlength]="lastNameMaxLength">
            <mat-error *ngIf="lastNameControl.hasError('required') && lastNameControl.touched"
                       i18n="@@request-quote-form_error-last-name-required">Please enter your last name
            </mat-error>
            <mat-error *ngIf="lastNameControl.hasError('maxlength')"
                       i18n="@@request-quote-form_error-last-name-maxlength">
                Your last name can't have more than {{lastNameMaxLength}} characters
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldCompanyTextId)"
                   formControlName="company" required [maxlength]="companyMaxLength">
            <mat-error *ngIf="companyControl.hasError('required') && companyControl.touched"
                       i18n="@@request-quote-form_error-company-required">Please enter your company
            </mat-error>
            <mat-error *ngIf="companyControl.hasError('maxlength')"
                       i18n="@@request-quote-form_error-company-maxlength">
                Your company name can't have more than {{companyMaxLength}} characters
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldStreetTextId)"
                   formControlName="street" required>
            <mat-error *ngIf="streetControl.hasError('required') && streetControl.touched"
                       i18n="@@request-quote-form_error-street-required">
                Please enter your street
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <mat-select [placeholder]="i18nDictionary.get(fieldCountryTextId)" formControlName="countryId" required
                        panelClass="country-select-panel">
                <mat-option *ngIf="countriesIsPending" [value]="false">
                    <mat-spinner [diameter]="20"></mat-spinner>
                </mat-option>
                <mat-option *ngFor="let country of _countries" [value]="country.iso2Code">
                    {{country.name}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="countryIdControl.hasError('required') && countryIdControl.touched"
                       i18n="@@request-quote-form_error-country-required">Please choose a country
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldZipTextId)"
                   formControlName="zipCode" required [maxlength]="zipCodeMaxLength">
            <mat-error *ngIf="zipCodeControl.hasError('required') && zipCodeControl.touched"
                       i18n="@@request-quote-form_error-zip-required">
                Please enter your zip code
            </mat-error>
            <mat-error *ngIf="zipCodeControl.hasError('maxlength')" i18n="@@request-quote-form_error-zip-maxlength">
                Your zip code can't have more than {{zipCodeMaxLength}} characters
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldCityTextId)"
                   formControlName="city" required [maxlength]="cityMaxLength">
            <mat-error *ngIf="cityControl.hasError('required') && cityControl.touched"
                       i18n="@@request-quote-form_error-city-required">
                Please enter your city
            </mat-error>
            <mat-error *ngIf="cityControl.hasError('maxlength')" i18n="@@request-quote-form_error-city-maxlength">
                Your city code can't have more than {{cityMaxLength}} characters
            </mat-error>
        </div>
        <div class="form-item-wrapper">
            <input type="text" class="form-input" matInput [placeholder]="i18nDictionary.get(fieldVatInTextId)"
                   formControlName="vat" required [maxlength]="vatMaxLength">
            <mat-error *ngIf="vatControl.hasError('required') && vatControl.touched"
                       i18n="@@request-quote-form_error-vat-in-required">
                Please enter your VAT Reg No
            </mat-error>
            <mat-error *ngIf="vatControl.hasError('maxlength')" i18n="@@request-quote-form_error-vat-in-maxlength">
                Your vat code can't have more than {{vatMaxLength}} characters
            </mat-error>
        </div>
    </div>

    <div class="menu footer">
        <button class="btn-primary main-btn" (click)="closeRequestQuote()" i18n="@@request-quote_cancel-button">Cancel
        </button>
        <button class="btn-primary main-btn" (click)="onRequestQuote()" [disabled]="form.errors">
            <span *ngIf="!isOrder" i18n="@@request-quote-form_request-button"
                  i18n="@@request-quote_request">Request</span>
            <span *ngIf="isOrder" i18n="@@request-quote-form_order-button" i18n="@@request-quote_order">Order</span>
        </button>
    </div>
</div>
